
import Transform from './Transform';


class Row {
    constructor(id, primary, xAxis, yAxis, connectedOnX) {
        this.id = id
        this.primary = primary
        this.xAxis = xAxis
        this.yAxis = yAxis
        this.transform = new Transform(0, 0, 1, 1)
        this.connectedOnX = connectedOnX
    }

    scale = (transform, zoomID, locked) => {
        let targetTransform = new Transform(transform.x, transform.y, transform.kx, transform.ky)

        if(locked && zoomID === this.yAxis.graph.zoomID) {
            targetTransform.kx = transform.kx
            targetTransform.x = this.transform.x

            const relCenter = this.calcRelativeCenter()
            const newPos = this.calcPosFromRelCenter(relCenter, transform)

            targetTransform.x = newPos.x
        }

        if(locked && zoomID === this.xAxis.graph.zoomID) {
            const relCenter = this.calcRelativeCenter()
            const newPos = this.calcPosFromRelCenter(relCenter, transform)
            targetTransform.y = newPos.y
        }

        if(!locked && zoomID === this.yAxis.graph.zoomID) {
            targetTransform.x = this.transform.x
            targetTransform.kx = this.transform.kx
        }

        if(!locked && zoomID === this.xAxis.graph.zoomID) {
            targetTransform.ky = this.transform.ky
            targetTransform.y = this.transform.y
        }

        this.transform = targetTransform
        return this.apply()
    }

    calcPrimaryFullSizeForScale = (kx, ky) => {
        const graph = this.primary.graph
        const fw = graph.x.range()[1] * kx
        const fh = graph.y.range()[0] * ky
        return {w: fw, h: fh}
    }

    calcRelativeScale = (transformOne, transformTwo) => {
        const sizeOne = this.calcPrimaryFullSizeForScale(transformOne.kx, transformOne.ky)
        const sizeTwo = this.calcPrimaryFullSizeForScale(transformTwo.kx, transformTwo.ky)
        return {kx: sizeTwo.w / sizeOne.w, ky: sizeTwo.h / sizeOne.h}
    }

    calcPosFromRelCenter = (relCenter, transform) => {
        const graph = this.primary.graph
        const w = graph.x.range()[1]
        const h = graph.y.range()[0]
        const fw = graph.x.range()[1] * transform.kx
        const fh = graph.y.range()[0] * transform.ky
        const absX = fw * relCenter.rx
        const absY = fh * relCenter.ry
       
        const nx = (w * 0.5) - absX
        const ny = (h * 0.5) - absY
       
        return {x: nx, y: ny}
    }

    calcRelativeOffsetFromRelativeMove = (relMove, transform) => {
        const graph = this.primary.graph
        const w = graph.x.range()[1] * transform.kx
        const h = graph.y.range()[0] * transform.ky

        return {x: w * relMove.x, y: h * relMove.y}
    }

    calcRelativeMove = (transformBefore, transformAfter) => {
        const graph = this.primary.graph
        const deltaX = transformAfter.x - transformBefore.x
        const deltaY = transformAfter.y - transformBefore.y

        const w = graph.x.range()[1] //* transformAfter.kx
        const h = graph.y.range()[0] //* transformAfter.ky

        return {x: deltaX / w, y: deltaY / h}
    } 

    calcAbsolutMoveFromRelativeMove = (relMove) => {
        const graph = this.primary.graph
        const w = graph.x.range()[1]
        const h = graph.y.range()[0]
        const rx = relMove.x * w
        const ry = relMove.y * h
        return {x: rx, y: ry}
    }

    scaleFromOrigin = (relScale, kx, ky, zo) => {
       
        const currentTransform = this.transform.copy()
        
        const fullSize = this.calcPrimaryFullSizeForScale(currentTransform.kx, currentTransform.ky)
        const newFullSize = this.calcPrimaryFullSizeForScale(kx, ky)
       
        const pW1 = fullSize.w// - graph.x.range()[1]
        const pH1 = fullSize.h// - graph.y.range()[0]

        const pW2 = newFullSize.w// - graph.x.range()[1]
        const pH2 = newFullSize.h// - graph.y.range()[0]

        const pDeltaW = pW2 - pW1
        const pDeltaH = pH2 - pH1

        currentTransform.kx = kx
        currentTransform.ky = ky


        currentTransform.x -= pDeltaW * zo.x
        currentTransform.y -= pDeltaH * zo.y

        return currentTransform
    }

    calcZoomOrigin = (transformBefore, transformAfter) => {
        
        const graph = this.primary.graph
        
        const w = graph.x.range()[1]
        const h = graph.y.range()[0]
        
        const sizeOne = this.calcPrimaryFullSizeForScale(transformBefore.kx, transformBefore.ky)
        const sizeTwo = this.calcPrimaryFullSizeForScale(transformAfter.kx, transformAfter.ky)

        const pSizeOneW = sizeOne.w - w
        const pSizeTwoW = sizeTwo.w - w

        const pSizeOneH = sizeOne.h - h
        const pSizeTwoH = sizeTwo.h - h

        const pDeltaW = pSizeTwoW - pSizeOneW
        const pDeltaH = pSizeTwoH - pSizeOneH

        const pDeltaX = transformAfter.x - transformBefore.x
        const pDeltaY = transformAfter.y - transformBefore.y

        const cX = pDeltaW !== 0 ? pDeltaX/pDeltaW : 0.5
        const cY = pDeltaH !== 0 ? pDeltaY/pDeltaH : 0.5

        return {x: Math.abs(cX), y: Math.abs(cY)}
    }
    
    calcRelativeCenter = () => {
        const graph = this.primary.graph
        const w = graph.x.range()[1]
        const h = graph.y.range()[0]
        const fw = graph.x.range()[1] * this.transform.kx
        const fh = graph.y.range()[0] * this.transform.ky

        const relX = ((w * 0.5) - this.transform.x) / fw
        const relY = ((h * 0.5) - this.transform.y) / fh

        return {rx: relX, ry: relY}
    }

    apply = () => {
        const primaryScale = this.primary.graph.setZoomTransform(this.transform)
        this.yAxis.graph.setZoomTransform(this.transform)
        
        this.primary.graph.update()
        this.yAxis.graph.update()

        return primaryScale
    }

    adjustOnLock = () => {
        return this.apply()
    }
    
    adjustAfterResize = () => {
        console.log("adjust after resize")
        const primaryTransform = this.primary.graph.getZoomTransform()
        this.transform = new Transform(primaryTransform.x, primaryTransform.y, primaryTransform.kx, primaryTransform.ky)
        return this.apply()
    }

    inheritScaleX = (transform, locked) => {
        let targetTransform = new Transform(transform.x, this.transform.y, transform.kx, this.transform.ky)
        

        if(locked) {
            const deltaK = this.transform.kx - transform.kx
            const nky = this.transform.ky - deltaK
            targetTransform.ky = nky

            const relCenter = this.calcRelativeCenter()
            const newPos = this.calcPosFromRelCenter(relCenter, targetTransform)
            targetTransform.y = newPos.y
        }

        this.transform = targetTransform
        return this.apply()
    }
}

class ChartGraphLinker {
    constructor(primary, primaryAxisX, primaryAxisY, secondary, secondaryAxisY, primaryZoomCallback) {
        this.primaryZoomCallback = primaryZoomCallback
        this.xAxis = primaryAxisX
        this.primary = primary
       
        this.rowsByKey = {}
        this.rows = []
        this.prow = new Row("primary", primary, primaryAxisX, primaryAxisY, [secondary.graph.zoomID])
        this.srow = new Row("secondary", secondary, primaryAxisX, secondaryAxisY, [primary.graph.zoomID])

        this.rowsByKey[primary.graph.zoomID] = this.prow
        this.rowsByKey[primaryAxisY.graph.zoomID] = this.prow

        this.rowsByKey[secondary.graph.zoomID] = this.srow
        this.rowsByKey[secondaryAxisY.graph.zoomID] = this.srow

        this.rows.push(this.prow)
        this.rows.push(this.srow)

        this.setInitalScale()
    }

    rowByZoomID = (zoomID) => {
        return this.rowsByKey[zoomID]
    }

    setInitalScale = () =>{
        this.prow.transform = new Transform(0, -14200, 40, 40)
        this.srow.transform = new Transform(0, -14200, 40, 40)
        this.prow.apply()
        this.srow.apply()
    } 

    adjustAfterResize(transform, primary) {
        this.rowsByKey[primary.zoomID].adjustAfterResize()
    }

    setLocked = (locked) => {
        this.scaleRatioIsLocked = locked
        this.prow.adjustOnLock()
    }

    graphSize(graph, kx, ky) {
        return {w: graph.x.range()[1] * kx, h: graph.y.range()[0] * ky}
    }

    allRowGraphs = () => {
        const elements = []
        this.rows.forEach((row) => {
            elements.push(row.primary.graph)
            elements.push(row.yAxis.graph)
        })
        elements.push(this.xAxis.graph)
        return elements
    }

    handleDeltaZoomFromOtherWidget = (before, after) => {

 
        
        const primaryRow = this.rowsByKey[this.primary.zoomID]
        const myTransform = primaryRow.transform.copy()
        let targetTransform = myTransform.copy()
        const ownSize = this.graphSize(primaryRow.primary.graph, 1, 1)
        const relativeOrigin = before.relativeOrigin
        const relMove = before.relMove


        const mousep = {x: relativeOrigin.x * ownSize.w, y: relativeOrigin.y * ownSize.h}

        const otherChartRelXZoom = after.transform.kx / before.transform.kx
        const otherChartRelYZoom = after.transform.ky / before.transform.ky

        let originx = myTransform.x
        let originy = myTransform.y

        const mouse_x = mousep.x - originx;
        const mouse_y = mousep.y - originy;

        const zoomX = myTransform.kx * otherChartRelXZoom
        const lastZoomX = myTransform.kx
        const zoomY = myTransform.ky * otherChartRelYZoom
        const lastZoomY = myTransform.ky

        const newx = mouse_x * (zoomX/lastZoomX);
        const newy = mouse_y * (zoomY/lastZoomY);

        originx += mouse_x - newx
        originy += mouse_y - newy

        targetTransform.x = originx
        targetTransform.y = originy
        targetTransform.kx = zoomX
        targetTransform.ky = zoomY

        targetTransform.x += relMove.x * ownSize.w
        targetTransform.y += relMove.y * ownSize.h

        this.handleZoomTransform({transform: targetTransform}, this.primary.graph.zoomID, false)
        return
    }

    handleZoomTransform(event, zoomID, broadcast = false) {
        const transform = event.transform
        const transformBefore = this.rowsByKey[this.primary.graph.zoomID].transform.copy()
        let resultingTransform = new Transform(0, 0, 1, 1) 
        
        if(zoomID === this.xAxis.graph.zoomID) {
            resultingTransform = this.rowsByKey[this.primary.graph.zoomID].scale(transform, zoomID, this.scaleRatioIsLocked)
            this.rowsByKey[this.primary.graph.zoomID].connectedOnX.forEach((connected) => {
                this.rowsByKey[connected].inheritScaleX(resultingTransform, this.scaleRatioIsLocked)
            });
        } 
        else if(this.rowsByKey[zoomID]) {
            resultingTransform = this.rowsByKey[zoomID].scale(transform, zoomID, this.scaleRatioIsLocked)
            this.rowsByKey[zoomID].connectedOnX.forEach((connected) => {
                this.rowsByKey[connected].inheritScaleX(resultingTransform, this.scaleRatioIsLocked)
            });
        }
        this.xAxis.graph.setZoomTransform(resultingTransform)
        this.xAxis.graph.update() 
        
        if(broadcast) {
            const primaryRow = this.rowsByKey[this.primary.zoomID]
            const transformAfter = this.rowsByKey[this.primary.graph.zoomID].transform
            const relScale = this.rowsByKey[this.primary.graph.zoomID].calcRelativeScale(transformBefore, transformAfter)
            const ownSize = this.graphSize(primaryRow.primary.graph, 1, 1)
            let relMove = {x: 0, y: 0}

            if((transformBefore.kx - transformAfter.kx === 0) && (transformBefore.ky - transformAfter.ky === 0)) {
                relMove = {x: (transformAfter.x - transformBefore.x)/ownSize.w, y: (transformAfter.y - transformBefore.y)/ownSize.h}
            }
            
            const offset ={x: event.sourceEvent.offsetX, y: event.sourceEvent.offsetY}
            const relativeOrigin = {x: offset.x / ownSize.w, y: offset.y / ownSize.h}

            this.primaryZoomCallback({relativeOrigin: relativeOrigin, graph: primaryRow.primary.graph, relMove: relMove, relScale: relScale, transform: transformBefore}, {relMove: relMove, relScale: relScale, transform: this.rowsByKey[this.primary.graph.zoomID].transform})
        }
    }
}

export default ChartGraphLinker;


// WEBPACK FOOTER //
// ./src/ChartGraphLinker.js